import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  userInfo: {},
  distributionStatusInfo: {}
};

export default function userCenter(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 获取个人中心数据
    case ACTION_TYPES.GET_USER_CENTER_INFO:
      result.userInfo = payload;
      break;
    // 获取分销员状态信息
    case ACTION_TYPES.GET_DISTRIBUTION_STATUS_INFO:
      result.distributionStatusInfo = payload;
      break;
    default:
      result = state;
  }
  return result;
}
